import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import './Pagination.css';

import { ReactComponent as ArrowDown } from '../../icons/arrow-down.svg';

function Pagination({ reduxSelector, reduxAction, totalPages, maxVisibleButtons = 5 }) {
  const dispatch = useDispatch();
  const currentPage = useSelector(reduxSelector); // Pobranie bieżącej strony z Redux
  const [isModalVisible, setIsModalVisible] = useState(false); // Czy modal jest widoczny
  const [inputValue, setInputValue] = useState(''); // Wartość wpisana w pole

  // Funkcja do zmiany strony
  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      dispatch(reduxAction(page)); // Aktualizacja bieżącej strony w Redux
    }
  };

  // Generowanie zakresu stron z obsługą "..."
  const generatePageButtons = () => {
    const buttons = [];
    const half = Math.floor(maxVisibleButtons / 2);

    if (totalPages <= maxVisibleButtons) {
      for (let i = 1; i <= totalPages; i++) {
        buttons.push(i);
      }
    } else {
      if (currentPage <= half + 1) {
        for (let i = 1; i <= maxVisibleButtons - 1; i++) {
          buttons.push(i);
        }
        buttons.push('...');
        buttons.push(totalPages);
      } else if (currentPage >= totalPages - half) {
        buttons.push(1);
        buttons.push('...');
        for (let i = totalPages - (maxVisibleButtons - 2); i <= totalPages; i++) {
          buttons.push(i);
        }
      } else {
        buttons.push(1);
        buttons.push('...');
        for (let i = currentPage - half + 1; i <= currentPage + half - 1; i++) {
          buttons.push(i);
        }
        buttons.push('...');
        buttons.push(totalPages);
      }
    }

    return buttons;
  };

  const pageButtons = generatePageButtons();

  // Obsługa zatwierdzenia numeru strony
  const handleInputSubmit = () => {
    const page = parseInt(inputValue, 10);
    if (!isNaN(page)) {
      changePage(page);
    }
    setIsModalVisible(false); // Ukryj modal po zatwierdzeniu
    setInputValue(''); // Wyczyść pole
  };

  return (
    <div className="pagination">
      <button
        className="pagination-button"
        disabled={currentPage === 1}
        onClick={() => changePage(currentPage - 1)}
      >
        &#10094;
      </button>
      {pageButtons.map((button, index) =>
        button === '...' ? (
          <span key={index} className="pagination-ellipsis">
            ...
          </span>
        ) : (
          <button 
            key={index}
            className={`pagination-button ${button === currentPage ? 'active' : ''}`}
            onClick={() => changePage(button)}
          >
            {button}
          </button>
        )
      )}
      <button
        className="pagination-button"
        disabled={currentPage === totalPages}
        onClick={() => changePage(currentPage + 1)}
      >
        &#10095;
      </button>

      {/* Przycisk z hamburgerem */}
      <button
        className="pagination-button pagination-button-separated"
        onClick={() => setIsModalVisible(true)}
      >
        Strona <ArrowDown />
      </button>

      {/* Modal */}
      {isModalVisible && (
        <div className="pagination-modal">
          <div className="pagination-modal-content">
            <h3>Wybierz stronę</h3>
            <input
              type="number"
              className="pagination-input"
              placeholder="Nr strony"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleInputSubmit()}
            />
            <div className="pagination-modal-buttons">
              <button className="pagination-submit" onClick={handleInputSubmit}>
                OK
              </button>
              <button
                className="pagination-cancel"
                onClick={() => setIsModalVisible(false)}
              >
                Anuluj
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

Pagination.propTypes = {
  reduxSelector: PropTypes.func.isRequired, // Funkcja selektora Redux do pobrania bieżącej strony
  reduxAction: PropTypes.func.isRequired, // Akcja Redux do zmiany strony
  totalPages: PropTypes.number.isRequired, // Całkowita liczba stron
  maxVisibleButtons: PropTypes.number, // Maksymalna liczba widocznych przycisków (domyślnie 5)
};

export default Pagination;